export default {
  buildingPassport: "GebäudePass",
  "building profile": "Gebäudeprofil",
  certificates: "Zertifikate",
  downloadAllFiles: "Alle Dateien herunterladen",
  downloadScenarios: "Download scenarios",
  "Energy & CO₂": "Energie & CO₂ ",
  energyConsultant: "Energieberater",
  modernization: "Modernisierungsszenarien",
  "technical Data": "Technische Daten",
  threeDViewer: "3D viewer",
  uploadFiles: "Dateien hochladen",
};
